__turbopack_context__.v({
  "icon": "Header-module__arFiJq__icon",
  "left": "Header-module__arFiJq__left",
  "logo": "Header-module__arFiJq__logo",
  "logoLink": "Header-module__arFiJq__logoLink",
  "mainBarContainer": "Header-module__arFiJq__mainBarContainer",
  "middle": "Header-module__arFiJq__middle",
  "middleItem": "Header-module__arFiJq__middleItem",
  "middleItemAnimation": "Header-module__arFiJq__middleItemAnimation",
  "right": "Header-module__arFiJq__right",
  "topBarContainer": "Header-module__arFiJq__topBarContainer",
  "topBarItem": "Header-module__arFiJq__topBarItem",
  "topBarLeft": "Header-module__arFiJq__topBarLeft",
  "topBarRight": "Header-module__arFiJq__topBarRight",
  "userButton": "Header-module__arFiJq__userButton",
});
